/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, {
  useState, useEffect, useRef,
} from 'react';
import {
  Form,
  Input,
  Row,
  Col,
  Spin,
  Card,
  DatePicker,
  Tabs,
  Modal,
  Progress,
  notification,
} from 'antd';
import { UsergroupAddOutlined } from '@ant-design/icons';
import {
  defaultOptions,
  allRequirementsPassed,
  validatePasswordRequirements,
} from 'utils/passwordRequirements';
import Table from 'components/Table';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import { onAlert, onError, onSuccess } from 'utils/handlers';
import {
  deleteUsuario,
  getUsuario,
  getUsuariosCustom,
  patchUsuario,
  patchUsuarioThrow,
  postGenerarUsuariosDesdeEmpleados,
  postUsuario,
  postUsuarioThrow,
} from 'api/usuarios/usuarios';
import getProcesoEnCursoTerminado from 'api/catalogos/ProcesoEnCursoTerminado';
import AvatarUploader from 'components/AvatarUploader';
import Select from 'components/Select';
import { checkToken } from 'api/utils';
import { formatReceived, formatReceivedValues } from 'utils/formatValues';
import FormSubmitControls from 'components/FormSubmitControls';
import TabPane from 'antd/lib/tabs/TabPane';
import { getEmpleadosFiltered } from 'api/estructuraOrganizacional/empleados';
import { useSelector } from 'react-redux';
import LadaNumero from 'components/LadaNumero';
import { getGrupos } from 'api/estructuraOrganizacional/grupos';
import { getFunciones } from 'api/usuarios/funciones';
import { getPermisosRoles, getRolesDeUsuario } from 'api/estructuraOrganizacional/rolesDeUsuario';
import { filterRoles, translatePermissions } from 'utils/normalizers';
import { getUsuariosPermisos, patchUsuariosPermisos, postUsuariosPermisos } from 'api/nominas/catalogos/usuariosLimitacionesInformacion';
import { patchPermisosUsuario, patchRolesUsuario } from 'api/usuarios/auth';
import { ESTATUS_AUTORIZADO } from 'utils/constants';
import UsuariosRoles from './UsuariosRoles';
import UsuariosLimitaciones from './UsuariosLimitaciones';
import UsuariosContrasena from './UsuariosContrasena';

const groupTabPermission = { model: 'group' };
const permissionstabPermission = { model: 'permission' };

export const usuarioTabsModels = [groupTabPermission, permissionstabPermission];

export const usuariosPermission = {
  permissionModel: 'usuario',
  catalogsModels: [
    'empleado',
    'permission',
    'group',
    'funcion',
    'justificaciondeusuarioexterno',
    'centrodecostos',
  ],
  tabsModels: usuarioTabsModels,
};

export const onErrorFields = (
  err,
  setLoading = null,
  formsInstances = [],
  setCurrentTabKey,
) => {
  if (typeof setLoading === 'function') {
    setLoading(false);
  }
  const errorKeys = err.errorFields.map((e) => e.name[0]);
  const formWithErrors = formsInstances.find(
    (obj) => obj.tabFields.some(
      (val) => errorKeys.includes(val),
    ),
  );
  if (formWithErrors) {
    setTimeout(() => {
      if (typeof setCurrentTabKey === 'function') {
        setCurrentTabKey(formWithErrors.tabKey);
      }
    });
  }
};

const Usuarios = ({ permission }) => {
  const [form] = Form.useForm();
  const [formRoles] = Form.useForm();
  const [formLimitaciones] = Form.useForm();
  const [formContrasena] = Form.useForm();
  const [selectedRowKeys, setselectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [currentTabKey, setCurrentTabKey] = useState('general');
  const [esEmpleado, setEsEmpleado] = useState(false);
  const ladaDefaultID = useSelector(({ auth }) => auth.entidad?.configuracion?.lada);
  const [roles, setRoles] = useState([]);
  const [funciones, setFunciones] = useState([]);
  const [permisos, setPermisos] = useState([]);
  const [aplicaTNE, setAplicaTNE] = useState(false);
  const [aplicaArea, setAplicaArea] = useState(false);
  const [usuarioLimitacionId, setUsuarioLimitacionId] = useState();
  const [options, setOptions] = useState(defaultOptions);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [visiblePwd, setVisiblePwd] = useState(false);
  const usuarioId = useSelector(({ auth }) => auth?.user?.id);
  const [disableEditar, setDisableEditar] = useState(false);
  const [confirmationGenerarVisible, setConfirmationGenerarVisible] = useState(false);
  const [isPollingGenerarUsuarios, setIsPollingGenerarUsuarios] = useState(false);
  const [progresoGenerarUsuarios, setProgresoGenerarUsuarios] = useState({ en_curso: 0, total: 0 });
  const [descripcionProcesoGenerarUsuarios, setDescripcionProcesoGenerarUsuarios] = useState(null);
  const pollingGenerarUsuariosRef = useRef(null);

  const requiredFormStructure = [
    {
      tabKey: 'general',
      tabFields: ['first_name', 'last_name', 'email', 'numero_de_celular', 'is_active'],
    },
    {
      tabKey: 'contrasena',
      tabFields: ['password'],
    },
  ];

  const requiredEditFormStructure = [
    {
      tabKey: 'general',
      tabFields: ['first_name', 'last_name', 'email', 'numero_de_celular', 'is_active'],
    },
  ];

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
        nombre: e?.id,
        apellido_paterno: e?.id,
        apellido_materno: e?.id,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  const fetchData = async () => {
    setLoading(true);
    const _data = await getUsuariosCustom();
    setData(formatReceivedClone(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _data,
        _empleados,
        _grupos,
        _roles,
        _funciones,
        _permisos,
      ] = await Promise.all([
        getUsuariosCustom(),
        getEmpleadosFiltered(),
        getGrupos(),
        getRolesDeUsuario({ estados_globales: ESTATUS_AUTORIZADO }),
        getFunciones({ estados_globales: ESTATUS_AUTORIZADO }),
        getPermisosRoles(),
      ]);
      const translatedPermissions = translatePermissions(_permisos);
      const filteredRoles = filterRoles(_grupos, _roles);
      if (mounted) {
        setData(formatReceivedClone(_data));
        setEmpleados(_empleados);
        setRoles(filteredRoles);
        setFunciones(_funciones);
        setPermisos(translatedPermissions);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setselectedRowKeys([]);
    setVisible(false);
    setCurrentTabKey('general');
    setEsEmpleado(false);
    setAplicaTNE(false);
    setAplicaArea(false);
    setUsuarioLimitacionId();
    setOptions(defaultOptions);
    setSelectedPermissions([]);
    setVisiblePwd(false);
    setDisableEditar(false);
    form.resetFields();
    formRoles.resetFields();
    formLimitaciones.resetFields();
    formContrasena.resetFields();
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _usuario = await getUsuario(match.id);
    setTimeout(() => {
      if (_usuario) {
        form.resetFields();
        setTimeout(async () => {
          _usuario?.id === usuarioId ? setDisableEditar(true) : setDisableEditar(false);
          const _userRoles = _usuario?.roles || [];
          const effectivePermissions = [
            ...new Set([
              ...(_usuario?.permisos || []),
              ..._userRoles.flatMap((rolId) => {
                const rObj = roles.find((r) => r.id === rolId);
                return rObj?.permissions || [];
              }),
            ]),
          ];
          const _limitaciones = await getUsuariosPermisos({ usuario: _usuario?.id } || []);
          setUsuarioLimitacionId(_limitaciones[0]?.id);
          setAplicaTNE(_limitaciones[0]?.aplica_limitacion_de_tipos_de_nomina_empleado);
          setAplicaArea(_limitaciones[0]?.aplica_limitacion_de_area);
          setEsEmpleado(_usuario?.es_externo);
          setSelectedPermissions(effectivePermissions);

          form.setFieldsValue(formatReceived(_usuario));
          formRoles.setFieldsValue({
            roles: _userRoles,
            funcion: _usuario?.funcion,
            justificacion: _usuario?.justificacion,
            observaciones: _usuario?.observaciones,
          });
          if (_limitaciones.length) {
            formLimitaciones.setFieldsValue(_limitaciones[0]);
          }
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = true) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formRoles.validateFields();
      await formContrasena.validateFields();
      const rolesData = formRoles.getFieldsValue();
      const values = {
        ...form.getFieldsValue(),
        funcion: rolesData?.funcion,
        justificacion: rolesData?.justificacion,
        observaciones: rolesData?.observaciones,
        ...formContrasena.getFieldsValue(),
      };
      // Si no se selecciona una lada se envía la configurada en la entidad,
      // solo cuando sí se capturó un número de teléfono (de lo contrario
      // se envía una lada "huérfana" sin número y el backend la rechaza
      // como si el teléfono fuera requerido)
      if (!values.lada && values.numero_de_celular) {
        values.lada = ladaDefaultID;
      }
      const [key] = selectedRowKeys;

      let saved;
      try {
        saved = await (key ? patchUsuarioThrow(key, values) : postUsuarioThrow(values));
      } catch (apiErr) {
        const errorData = apiErr?.response?.data;
        if (errorData && typeof errorData === 'object' && !errorData.detail) {
          const fieldErrors = Object.entries(errorData)
            .map(([fieldKey, errors]) => ({
              name: fieldKey,
              errors: Array.isArray(errors) ? errors : [String(errors)],
            }))
            .filter((f) => f.errors.length > 0);
          if (fieldErrors.length) form.setFields(fieldErrors);
        }
        onError(apiErr);
        setLoading(false);
        return;
      }

      if (saved) {
        const selectedRoles = rolesData.roles || [];
        await patchRolesUsuario(saved.id, selectedRoles);
        await patchPermisosUsuario(saved.id, selectedPermissions);
        if (_continue) {
          await fetchData();
          setselectedRowKeys([saved.id]);
          // Al editar un guardar un usuario se verifica si ya tiene un registro en usuariosPermisos
          const valuesLimitaciones = {
            ...formLimitaciones.getFieldsValue(),
            usuario: saved.id,
          };
          const _usuariosPermisos = await getUsuariosPermisos({ usuario: saved.id }) || [];
          if (_usuariosPermisos.length > 0) {
            const usuarioPermisoId = _usuariosPermisos[0].id;
            await patchUsuariosPermisos(usuarioPermisoId, valuesLimitaciones);
            setUsuarioLimitacionId(usuarioPermisoId);
          } else {
            const savedLimitacion = await postUsuariosPermisos(valuesLimitaciones);
            setUsuarioLimitacionId(savedLimitacion?.id);
          }

          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
        // onAlert('Recuerda agregar el usuario a la Entidad Pública para poder utilizarlo');
      }
      setLoading(false);
    } catch (err) {
      if (err.errorFields) {
        // Si se está creando un usuario o se está editando la contraseña se validan las contraseñas
        if (selectedRowKeys.length <= 0 || visiblePwd === true) {
          onErrorFields(
            err,
            setLoading,
            requiredFormStructure,
            setCurrentTabKey,
          );
        } else {
          onErrorFields(
            err,
            setLoading,
            requiredEditFormStructure,
            setCurrentTabKey,
          );
        }
      }
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteUsuario(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setselectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    const [key] = selectedRowKeys;
    if (key === usuarioId) {
      onAlert('Un usuario no se puede eliminar a si mismo');
    } else {
      setVisibleAlert(true);
    }
  };

  const onClickActivate = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      const values = data?.find((e) => e?.id === key);
      const vals = {
        ...values,
        is_active: true,
      };
      const saved = await patchUsuario(key, vals);
      if (saved) {
        onSuccess(saved);
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickDeactivate = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      const values = data?.find((e) => e?.id === key);
      const vals = {
        ...values,
        is_active: false,
      };
      const saved = await patchUsuario(key, vals);
      if (saved) {
        onSuccess(saved);
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  // Dispara el proceso en background que genera los Usuarios de los Empleados
  // activos sin usuario. El backend responde 202 con la `descripcion` del
  // ProcesoEnCursoTerminado a consultar por polling.
  const handleOnFinishGenerarUsuarios = async () => {
    try {
      setLoading(true);
      const response = await postGenerarUsuariosDesdeEmpleados();
      if (response?.status === 202) {
        setConfirmationGenerarVisible(false);
        setDescripcionProcesoGenerarUsuarios(response.data.descripcion);
        setIsPollingGenerarUsuarios(true);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  // Polling — generación de Usuarios desde Empleados en background (cada 2s, máx ~11 min)
  useEffect(() => {
    if (!isPollingGenerarUsuarios || !descripcionProcesoGenerarUsuarios) return () => {};

    let intentos = 0;
    const maxIntentos = 340;

    pollingGenerarUsuariosRef.current = setInterval(async () => {
      try {
        intentos += 1;
        const lista = await getProcesoEnCursoTerminado({
          descripcion: descripcionProcesoGenerarUsuarios,
        });
        const proceso = lista[0];

        if (proceso) {
          setProgresoGenerarUsuarios({
            en_curso: proceso.registro_en_curso || 0,
            total: proceso.total_registros || 0,
          });
        }

        const termino = proceso && proceso.procesando === false;
        if (termino || intentos >= maxIntentos) {
          clearInterval(pollingGenerarUsuariosRef.current);
          pollingGenerarUsuariosRef.current = null;
          setIsPollingGenerarUsuarios(false);
          setDescripcionProcesoGenerarUsuarios(null);
          setProgresoGenerarUsuarios({ en_curso: 0, total: 0 });

          if (proceso?.mensaje) {
            notification.success({
              message: 'Proceso completado',
              description: proceso.mensaje,
              placement: 'topRight',
              duration: 8,
            });
          }
          fetchData();
        }
      } catch (_err) {
        // No se interrumpe el polling: el siguiente tick reintenta. Si el
        // error es por sesión expirada, utils/api.js ya avisó y cerró
        // sesión; aquí solo dejamos rastro para diagnóstico.
        // eslint-disable-next-line no-console
        console.error('[polling generación masiva de usuarios] error al consultar estado', _err);
      }
    }, 2000);

    return () => {
      if (pollingGenerarUsuariosRef.current) {
        clearInterval(pollingGenerarUsuariosRef.current);
        pollingGenerarUsuariosRef.current = null;
      }
    };
  }, [isPollingGenerarUsuarios, descripcionProcesoGenerarUsuarios]);

  const onChangeEmpleado = (val) => {
    if (val) {
      const _empleado = empleados.find((e) => e.id === val);
      form.setFieldsValue({
        first_name: _empleado?.nombre,
        last_name: _empleado?.apellido_paterno,
        second_last_name: _empleado?.apellido_materno,
      });
    }
  };

  const columns = [
    {
      titleText: 'Correo Electrónico',
      dataIndex: 'email',
      key: 'email',
      width: 350,
    },
    {
      titleText: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
      width: 300,
      render: (val) => {
        const _usuario = data.find((e) => e.id === val);
        if (_usuario?.empleado) {
          const _empleado = empleados.find((e) => e.id === _usuario?.empleado);
          return _empleado?.nombre;
        }
        return _usuario?.first_name;
      },
    },
    {
      titleText: 'Apellido Paterno',
      dataIndex: 'apellido_paterno',
      key: 'apellido_paterno',
      width: 300,
      render: (val) => {
        const _usuario = data.find((e) => e.id === val);
        if (_usuario?.empleado) {
          const _empleado = empleados.find((e) => e.id === _usuario?.empleado);
          return _empleado?.apellido_paterno;
        }
        return _usuario?.last_name;
      },
    },
    {
      titleText: 'Apellido Materno',
      dataIndex: 'apellido_materno',
      key: 'apellido_materno',
      width: 300,
      render: (val) => {
        const _usuario = data.find((e) => e.id === val);
        if (_usuario?.empleado) {
          const _empleado = empleados.find((e) => e.id === _usuario?.empleado);
          return `${_empleado?.apellido_materno || ''}`;
        }
        return `${_usuario?.second_last_name || ''}`;
      },
    },
    {
      titleText: 'Es Empleado',
      dataIndex: 'es_externo',
      key: 'es_externo',
      width: 150,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Rol de Usuario',
      dataIndex: 'roles',
      key: 'roles',
      width: 250,
      render: (val) => val
        .map((_rolId) => roles.find((e) => e.id === _rolId)?.name)
        .filter(Boolean)
        .join(', '),
    },
    {
      titleText: 'Función',
      dataIndex: 'funcion',
      key: 'funcion',
      width: 250,
      render: (val) => funciones.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'is_active',
      key: 'is_active',
      width: 150,
      render: (val) => (val ? 'Activo' : 'Inactivo'),
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    email: [
      requiredRule,
      {
        type: 'email',
      },
    ],
    email_alternativo: [
      {
        type: 'email',
      },
    ],
    password: [
      requiredRule,
      {
        validator: async () => {
          const pwd = formContrasena.getFieldValue('password');
          if (pwd) {
            if (!allRequirementsPassed(pwd)) {
              throw new Error('La contraseña no cumple con los requisitos');
            }
          }
        },
      },
    ],
    confirmPassword: [
      requiredRule,
      {
        validator: async (rule, value) => {
          const pwd = formContrasena.getFieldValue('password');
          if (value && value !== pwd) {
            throw new Error('Las contraseñas no coinciden.');
          }
        },
      },
    ],
  };

  let timeout = null;
  const onFormValuesChange = (changedValues, allValues) => {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      const { password } = changedValues;
      if (password) {
        const newOps = validatePasswordRequirements(password, 33);
        setOptions(newOps);
      } else if (!allValues.password) {
        setOptions(defaultOptions);
      }
      formContrasena.validateFields(['password', 'confirmPassword']);
    }, 0);
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Table
            data={data}
            cols={columns}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
              onClickActivate,
              onClickDeactivate,
            }}
            allowActivate
            allowDeactivate
            disableActivate={data?.find((e) => e?.id === selectedRowKeys[0])?.is_active}
            disableDeactivate={!data?.find((e) => e?.id === selectedRowKeys[0])?.is_active}
            permission={permission}
            allowExportPDF={false}
            customActions={[
              {
                onClick: () => setConfirmationGenerarVisible(true),
                permission: { model: 'usuario', action: 'generar' },
                text: 'Crear Usuarios a Partir de Empleados',
                icon: <UsergroupAddOutlined />,
                disabledBySelection: false,
              },
            ]}
          />
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Usuario`}
            extra={(
              <FormSubmitControls
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
                onFinishText="Guardar y Continuar"
                allowSave={!disableEditar}
              />
            )}
            bordered={false}
          >
            <Tabs
              onChange={setCurrentTabKey}
              activeKey={currentTabKey}
              type="card"
            >
              <TabPane
                tab="Información General"
                key="general"
                forceRender
              >
                <Form
                  layout="vertical"
                  form={form}
                  name="general"
                  onFinish={() => onFinish()}
                  scrollToFirstError
                >
                  <Row gutter={10}>
                    <Col xs={24} sm={24} md={8}>
                      <AvatarUploader
                        form={form}
                        imageURL={form.getFieldValue('foto')}
                        disabled={disableEditar}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="es_externo"
                        label="Es Empleado"
                        hasFeedback
                        rules={rules.required}
                        initialValue={false}
                      >
                        <Select
                          trueFalse
                          onChange={(val) => {
                            setEsEmpleado(val);
                            form.resetFields(['empleado', 'first_name', 'last_name', 'second_last_name']);
                          }}
                          disabled={disableEditar}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        label="No. y Nombre del Empleado"
                        name="empleado"
                        hasFeedback
                      >
                        <Select
                          dataSource={empleados}
                          labelProp="numero_y_nombre_completo"
                          keyProp="id"
                          onChange={onChangeEmpleado}
                          disabled={!esEmpleado || disableEditar}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="first_name"
                        label="Nombre"
                        rules={!esEmpleado && rules.required}
                      >
                        <Input
                          allowClear
                          disabled={esEmpleado || disableEditar}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="last_name"
                        label="Apellido Paterno"
                        rules={!esEmpleado && rules.required}
                      >
                        <Input
                          allowClear
                          disabled={esEmpleado || disableEditar}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="second_last_name"
                        label="Apellido Materno"
                      >
                        <Input
                          allowClear
                          disabled={esEmpleado || disableEditar}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="email"
                        label="Correo Electrónico"
                        rules={!esEmpleado && rules.email}
                        hasFeedback
                      >
                        <Input
                          disabled={esEmpleado || disableEditar}
                          allowClear
                        />
                      </Form.Item>
                    </Col>
                    <LadaNumero
                      form={form}
                      names={{
                        lada: 'lada',
                        numero: 'numero_de_celular',
                      }}
                      disabled={disableEditar}
                    />
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="email_alternativo"
                        label="Correo Electrónico Alternativo"
                        rules={rules.email_alternativo}
                        hasFeedback
                      >
                        <Input
                          allowClear
                          disabled={disableEditar}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="is_active"
                        label="Activo"
                        rules={rules.required}
                        initialValue
                      >
                        <Select
                          trueFalse
                          disabled
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="fecha_de_vencimiento"
                        label="Vigencia Final"
                      >
                        <DatePicker
                          format="DD/MM/YYYY"
                          placeholder=""
                          disabled={disableEditar}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </TabPane>
              <TabPane
                tab="Roles y Permisos"
                key="roles"
                forceRender
              >
                <UsuariosRoles
                  form={formRoles}
                  roles={roles}
                  funciones={funciones}
                  permisos={permisos}
                  loading={loading}
                  rules={rules}
                  selectedPermissions={selectedPermissions}
                  setSelectedPermissions={setSelectedPermissions}
                  disableEditar={disableEditar}
                />
              </TabPane>
              <TabPane
                tab="Limitaciones"
                key="limitaciones"
                disabled={selectedRowKeys.length <= 0}
              >
                <UsuariosLimitaciones
                  form={formLimitaciones}
                  usuarioLimitacionId={usuarioLimitacionId}
                  rules={rules}
                  aplicaTNE={aplicaTNE}
                  setAplicaTNE={setAplicaTNE}
                  aplicaArea={aplicaArea}
                  setAplicaArea={setAplicaArea}
                  loading={loading}
                  disableEditar={disableEditar}
                />
              </TabPane>
              <TabPane
                tab="Contraseña"
                key="contrasena"
                forceRender
              >
                <UsuariosContrasena
                  form={formContrasena}
                  loading={loading}
                  rules={rules}
                  onValuesChange={onFormValuesChange}
                  options={options}
                  selectedRowKeys={selectedRowKeys}
                  visiblePwd={visiblePwd}
                  setVisiblePwd={setVisiblePwd}
                  disableEditar={disableEditar}
                />
              </TabPane>
            </Tabs>
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`el Usuario ${form.getFieldValue('first_name')} ${form.getFieldValue('last_name')} ${form.getFieldValue('second_last_name') || ''}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishGenerarUsuarios}
          onFinishText="Generar"
          onFinishIcon={<UsergroupAddOutlined />}
          onCancel={() => setConfirmationGenerarVisible(false)}
          open={confirmationGenerarVisible}
          contentTitle="Generar los Usuarios de los Empleados activos que aún no tienen uno"
          loading={loading}
        />
        <Modal
          open={isPollingGenerarUsuarios}
          title="Generando Usuarios..."
          footer={null}
          closable={false}
          maskClosable={false}
          centered
        >
          <div style={{ textAlign: 'center', padding: '16px 0' }}>
            <Progress
              type="circle"
              percent={
                progresoGenerarUsuarios.total > 0
                  ? Math.round((progresoGenerarUsuarios.en_curso / progresoGenerarUsuarios.total) * 100)
                  : 0
              }
            />
            <p style={{ marginTop: 16 }}>
              {progresoGenerarUsuarios.en_curso}
              {' / '}
              {progresoGenerarUsuarios.total}
              {' empleados procesados'}
            </p>
          </div>
        </Modal>
      </Spin>
    </Row>
  );
};

export default Usuarios;
